module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_May2020-a88d0d71ada519d6a4df58cf9c3f55ab.pdf";